import React from 'react'

const Areas = () => {

  const areas = [
    "Badarpur",
    "Bawana",
    "Daryaganj",
    "Dwarka",
    "Janakpuri",
    "Pitampura",
    "Rajouri Garden",
    "Ramesh Nagar",
    "Rohini",
    "Nangloi",
    "Naraina",
    "Nilothi",
    "Okhla Industrial Area",
    "Palam",
    "Paschim Vihar",
    "Kirti Nagar",
    "Lajpat Nagar",
    "Mongolpuri",
    "Mundka",
    "Patel Nagar",
    "Chandni Chowk",
    "Chattarpur",
    "Saket",
    "Sangam Vihar",
    "Siraspur",
    "Uttam Nagar"
  ];

  return (
    <section className="w-full bg-white py-10 px-4">
      <div className="mx-auto max-w-5xl text-center">

        <h2 className="mb-5 text-xl font-semibold text-gray-800 lg:text-3xl sm:text-[24px]">
          Areas We Serve
        </h2>

        <div className="flex flex-wrap justify-center gap-x-3 gap-y-2 text-sm text-gray-600">

          {areas
            .sort((a, b) => a.localeCompare(b))
            .map((area, index) => (
              <span key={index} className="flex items-center gap-1">
                <span className="text-blue-500">•</span> {area}
              </span>
            ))}

        </div>

      </div>
    </section>
  )
}

export default Areas